import * as React from "react";
import {Component} from "react";
import styles from "../styles/wizards/AddBuildingWizard.scss";
import autobind from "autobind-decorator";
import AddBuildingIcon from "../assets/images/add-building-60x60.svg";
import {__, mapStateToProps, setTableParams, validateForm} from "../core/utils";
import {withRouter} from "react-router";
import {getStagesLanguages} from "../redux/actions/table/stages";
import {setNotification} from "../redux/actions/general/notification";
import {createBuilding, listBuildings} from "../redux/actions/table/buildings";
import AddBuildingForm from "../forms/add_building_wizard/AddBuildingForm";

@withRouter
@mapStateToProps(state => ({
	table: state.table["buildings"],
}))
class AddBuildingWizard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			project_languages: null
		}
	}

	componentDidMount() {
		getStagesLanguages(this.props.match.params.stage).then(({response}) => {
			this.setState({project_languages: response.data});
		});
	}

	@autobind
	_handleSubmit(formData) {
		const {edit} = formData;

		formData = _.omit(formData, ['edit']);

		return validateForm(
			createBuilding(this.props.match.params.stage, formData).then(({response}) => {
				listBuildings(this.props.match.params.stage).then(() => {
					if(edit) {
						setTableParams('buildings', {
							clicked_row: response.data.id
						});
					}
				});

				setTableParams('buildings', {
					actioned_row: undefined,
					selected_rows: []
				});

				this.props.onClose();

				setNotification(__("wizard.add-building.message.success"));
			})
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>{__('wizard.add-building.title.add-new-building')}</span>
						<span>{__('wizard.add-building.subtitle.add-new-building')}</span>
					</div>
					<div className={styles.right}>
						<AddBuildingIcon />
					</div>
				</div>
				<div className={styles.body}>
					{this.state.project_languages && <AddBuildingForm
						projectLanguages={this.state.project_languages}
						onSubmit={this._handleSubmit}
						initialValues={{
							title: {},
							description: {},
						}}
					/>}
				</div>
			</>
		);
	}
}

export default AddBuildingWizard;